import { render, staticRenderFns } from "./CounselingQuestionOption.vue?vue&type=template&id=e2b70032&"
import script from "./CounselingQuestionOption.vue?vue&type=script&lang=js&"
export * from "./CounselingQuestionOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports